import { render } from "./MerchantManageEditPage.vue?vue&type=template&id=764b2e44&lang=true"
import script from "./MerchantManageEditPage.vue?vue&type=script&lang=js"
export * from "./MerchantManageEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__